export default __webpack_public_path__ + "static/media/VirtualWin_159x150.ea1d715b.png";